/*
 * @Author: kevinqq 350910378@qq.com
 * @Date: 2025-02-19 14:23:23
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-03 22:02:06
 * @FilePath: \baishu_react_ui\src\components\BsySystemLeftMenu\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "./index.css";
import { NavLink, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import PropTypes from "prop-types";
import icon from "../../images/team-icon.png";
import { createTooltip } from "../../utils/createTooltip";

class BsySystemLeftMenu extends React.Component {
  componentDidMount = () => {
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  render() {
    return (
      <div className={"bsy-left-menu"}>
        <NavLink
          onClick={this.toHome}
          className="go-home"
          data-for="go-home-Tip"
          data-tip={this.props.backTitle}
          onMouseEnter={(e) => {
            if (this.props.backTitle) {
              this.showTooltip(
                e.currentTarget,
                this.props.backTitle,
                "bottom",
                10
              );
            }
          }}
          onMouseLeave={() => {
            this.hideTooltip();
          }}
          to={
            window.rootDirectroy +
            (this.props.homeLink ? this.props.homeLink : "/")
          }
        >
          {this.props.homeIcon ? (
            this.props.homeIcon()
          ) : (
            <img
              style={{
                width: "26px",
                height: "26px",
              }}
              src={icon}
              alt=""
            ></img>
          )}
        </NavLink>
        {!this.props.noHomeLine === false ? "" : <div className="nav-split" />}
        {this.props.onRenderTitle ? (
          this.props.onRenderTitle()
        ) : (
          <NavLink
            className={
              "left-title" + (this.props.onTitleClick ? " clickable" : "")
            }
            title={this.props.title}
            onClick={this.props.onTitleClick}
          >
            <span className="">{this.props.title}</span>
          </NavLink>
        )}
      </div>
    );
  }
}

BsySystemLeftMenu.propTypes = {
  onRenderTitle: PropTypes.func, // 标签，考虑某些
  title: PropTypes.string,
  onTitleClick: PropTypes.func,
  backTitle: PropTypes.string,
  noHomeLine: PropTypes.bool,
  homeLink: PropTypes.string,
  homeIcon: PropTypes.func,
};

export default withRouter(BsySystemLeftMenu);
